import i18n from '@/lang/index'

export const statusList = {
  INACTIVE: {
    value: 'INACTIVE',
    label: i18n.global.t('leaflets.statusList.INACTIVE')
  },
  READY_FOR_ACTIVATION: {
    value: 'READY_FOR_ACTIVATION',
    label: i18n.global.t('leaflets.statusList.READY_FOR_ACTIVATION')
  },
  ACTIVE: {
    value: 'ACTIVE',
    label: i18n.global.t('leaflets.statusList.ACTIVE')
  },
  READY_FOR_DISACTIVATION: {
    value: 'READY_FOR_DISACTIVATION',
    label: i18n.global.t('leaflets.statusList.READY_FOR_DISACTIVATION')
  },
  DELETED: {
    value: 'DELETED',
    label: i18n.global.t('leaflets.statusList.DELETED')
  }
}

export const ACTIVE_STATUSES = [statusList.ACTIVE.value, statusList.READY_FOR_DISACTIVATION.value]

export const INACTIVE_STATUSES = [statusList.INACTIVE.value, statusList.READY_FOR_ACTIVATION.value]

export const CREATE_OPTIONS = [
  {
    label: statusList.READY_FOR_ACTIVATION.label,
    value: statusList.READY_FOR_ACTIVATION.value
  },
  {
    label: statusList.INACTIVE.label,
    value: statusList.INACTIVE.value
  }
]

export const ACTIVE_OPTIONS = [
  {
    label: statusList.ACTIVE.label,
    value: statusList.ACTIVE.value
  },
  {
    label: statusList.READY_FOR_DISACTIVATION.label,
    value: statusList.READY_FOR_DISACTIVATION.value
  }
]

export const INACTIVE_OPTIONS = [
  {
    label: statusList.INACTIVE.label,
    value: statusList.INACTIVE.value
  },
  {
    label: statusList.READY_FOR_ACTIVATION.label,
    value: statusList.READY_FOR_ACTIVATION.value
  }
]

export const DELETED_OPTIONS = [
  {
    label: statusList.DELETED.label,
    value: statusList.DELETED.value
  },
  {
    label: statusList.READY_FOR_ACTIVATION.label,
    value: statusList.READY_FOR_ACTIVATION.value
  }
]

export const URL_TYPES = ['LONG_URL', 'REDIRECT_URL', 'PAGE_REDIRECT_URL', 'PAGE_LONG_URL', 'THUMBNAIL_TRACKING_URL']
